<div class="activity-type">
  <i class="pi pi-wave-pulse"></i>

  @if (activityType === ExerciseActivityTypeEnum.Active) {
    Aktiv
  } @else if (activityType === ExerciseActivityTypeEnum.Assistive) {
    Aktiv assistiv
  } @else if (activityType === ExerciseActivityTypeEnum.Passive) {
    Passiv
  }
</div>
